import _defaults from 'lodash/defaults'

import { mergeResourceStores } from '../_helpers/ResourceStore'

export default {
  getters: {
    TravelInfo: (state, getters) => {
      return _defaults(
        getters.currentTripDashboardId
          ? getters.Trips[getters.currentTripDashboardId].travel_info
          : {},
        {
          'section-heading': 'Travel Information',
          'section-subheading':
            '<p>Below you will find all resources and links about your trip.</p>',
          resource_stores: [
            {
              files: [],
              links: [],
              pages: [],
              title: 'Passport and Visa Requirements',
              tag: 'passport-and-visa-requirements',
              order: 0
            },
            {
              files: [],
              links: [],
              pages: [],
              title: 'Health and Vaccination Requirements',
              tag: 'health-and-vaccination-requirements',
              order: 1
            },
            {
              files: [],
              links: [],
              pages: [],
              title: 'Luggage Requirement',
              tag: 'luggage-requirement',
              order: 2
            },
            {
              files: [],
              links: [],
              pages: [],
              title: 'Additional Information to Prepare your Trip',
              tag: 'additional-information-to-prepare-your-trip',
              order: 3
            },
            {
              files: [],
              links: [],
              pages: [],
              title: 'Packing Information',
              tag: 'packing-information',
              order: 4
            },
            {
              files: [],
              links: [],
              pages: [],
              title: 'More Information',
              tag: 'more-information',
              order: 5
            }
          ]
        }
      )
    },
    TravelInfoMergedResourceStore: (state, getters) => {
      return mergeResourceStores(getters.TravelInfo.resource_stores, 'Travel Info')
    }
  }
}
